<template>

    <div style="background-color: #f7f7f7; width: 99%; height: 100vh; padding: 8px 8px 0 8px;">
        <hSearchForm ref="hSearchForm" :searchItems="searchItems" @handleSearch="handleSearch" />

        <hTable ref="hTable" style="margin-top: 20px" :tableProps="tableProps" :queryParams="queryParams"
            functionKey="getKeyPageList" :operateButtons="operateButtons" @emitButtonKey="emitButtonKey" />

    </div>

</template>
<script setup>
import useUserStore from "@/store/modules/user";
import { getProvincesDetail } from '@/api/home'
import { getCurrentInstance, ref } from 'vue';
import { useRouter } from "vue-router";
import { tableProps, searchItems, operateButtons } from "./keyListConfig";
const { proxy } = getCurrentInstance();
let queryParams = ref({})
const router = useRouter()
function handleSearch(params, isButtonSearch) {
    queryParams.value = params;
    proxy.$refs["hTable"].getList(queryParams.value, isButtonSearch);
}

function emitButtonKey(data) {
    if (data.key === 'login') {
        doLogin(data)
    }
}
function doLogin(data) {
    useUserStore()
        .wanKeylogin(data.rowData.userId)
        .then((res) => {

            if (res.success) {
                proxy.$message.success("登录成功");
                useUserStore().getInfo().then(rs => {
                    const provinceId = data.rowData.provinceId;
                    const urlData = {
                        2: "bj",
                        21: "tj",
                        28: "heb",
                        241: "sx",
                        867: "sh",
                        383: "nm",
                        506: "ln",
                        635: "jl",
                        713: "hl",
                        1018: "zj",
                        1131: "ah",
                        1269: "fj",
                        1373: "jx",
                        1496: "sd",
                        1671: "hen",
                        1866: "hb",
                        1996: "hn",
                        2146: "gd",
                        2308: "gx",
                        2446: "hi",
                        2516: "sc",
                        2737: "gz",
                        2840: "yn",
                        2994: "xz",
                        3076: "sn",
                        3204: "gs",
                        3317: "qh",
                        3370: "nx",
                        3403: "xj",
                        3685: "xjscjsbt"
                    };
                    const linkCode = urlData[provinceId];
                    if (linkCode) {
                        router.push('/detail/' + linkCode);
                    } else {
                        router.push('/detail/' + provinceId);
                    }
                })

            } else {
                proxy.$message.error(res.message);
            }

        })

}
</script>
